import Axios from "axios";
import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { TargetInvitation } from "@/modules/targets/viewmodels/TargetInvitation";

export const state = {
  targetInvitations: [],
};

export const getters = Object.assign(
  {
    targetInvitations: (state) => {
      return state.targetInvitations;
    },
    targetInvitation: (state) => (Id) => {
      return state.targetInvitations.find((e) => e.id === Id);
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/target-invitations",
    TargetInvitation,
    {
      AfterShow: (name, data) => {
        let el = state.targetInvitations.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.targetInvitations.push(data);
        }
        return data;
      },
    },
    {
      //========================================================================================
      /**                                                                                     *
       * * My                                                                                 *
       * Returns my target invitations                                                   *
       * this.$store.getters['targetinvitation/api'].Custom.My()                                  *
       *                                                                                      */
      //========================================================================================

      My: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL + "/api/target-invitations/my"
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new TargetInvitation(Entry);
        });

        Vue.set(state, "targetInvitations", data);

        return data;
      },

      /**
       * Accepts a target invitation
       * this.$store.getters['targetinvitation/api'].Custom.Accept(RequestId)
       */
      Accept: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL +
              "/api/target-invitations/" +
              Id +
              "/accept"
          )
          .catch((err) => {
            throw Error(err);
          });

        state.targetInvitations.splice(
          state.targetInvitations.findIndex((e) => e.id === Id),
          1
        );
        return ApiResult;
      },

      /**
       * Rejects a target invitation
       * this.$store.getters['targetinvitation/api'].Custom.Reject(RequestId)
       */
      Reject: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL +
              "/api/target-invitations/" +
              Id +
              "/reject"
          )
          .catch((err) => {
            throw Error(err);
          });

        state.targetInvitations.splice(
          state.targetInvitations.findIndex((e) => e.id === Id),
          1
        );

        return ApiResult;
      },

      /**
       * Send a target invitation
       * this.$store.getters['targetinvitation/api'].Custom.Invite(Params)
       */
      Invite: async (Params) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL +
              "/api/targets/" +
              Params.id +
              "/invite",
            { friends: Params.friends }
          )
          .catch((err) => {
            throw Error(err);
          });

        return ApiResult;
      },
    }
  )
);

// mutations
export const mutations = {
  addTargetInvitation: (state, Element) => {
    let idx = state.targetInvitations.findIndex((e) => e.id === Element.id);
    if (idx !== -1) {
      state.targetInvitations[idx] = Element;
    } else {
      state.targetInvitations.push(Element);
    }
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/target-invitations",
  [],
  {
    async addTargetInvitation({ commit }, Element) {
      commit("addTargetInvitation", Element);
    },
  }
);
